module.exports = __webpack_public_path__ + "img/LogoPPmedium.2eb07394.png";